import { Component } from '@angular/core';
import { BcFooterComponent } from '@bancolombia/design-system-web/bc-footer';

@Component({
    selector: 'app-main-footer',
    templateUrl: './main-footer.component.html',
    styleUrls: ['./main-footer.component.sass'],
    imports: [
      BcFooterComponent
    ],
})
export class MainFooterComponent {
  year: number = new Date().getFullYear();
}
